module.exports = __webpack_public_path__ + "img/04.a0308399.jpg";